import React, { memo, useMemo } from 'react';

import { Typography } from '@material-ui/core';
import { FilterList } from '@material-ui/icons';
import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';

import { t, number } from '~/helpers';

import { IconTruck } from '..';

import * as S from './styles';

function Truck({ data, ground }) {
  const colorProg = useMemo(() => {
    if (!isEmpty(data)) {
      switch (Number(data.statusPreset)) {
        case 1:
        default:
          return '#666'; // Cinza
        case 2:
        case 3:
          return '#ff8c00'; // Laranja
        case 4:
          return '#008000'; // Verde
        case 5:
          return '#ff0000'; // Vermelho
        case 6:
          return '#a020f0'; // Roxo
      }
    }
    return '#666';
  }, [data]);

  const percentage = useMemo(
    () =>
      data?.volumeProgramado === 0
        ? 0
        : Number(
            (data?.volumeAmbienteCarregado * 100) / data?.volumeProgramado
          ),
    [data.volumeAmbienteCarregado, data.volumeProgramado]
  );

  const percentageDescarregado = useMemo(
    () =>
      data?.volumeProgramado === 0
        ? 0
        : Number(
            (data?.volumeAmbienteDescarregado * 100) / data?.volumeProgramado
          ),
    [data.volumeAmbienteDescarregado, data.volumeProgramado]
  );

  return (
    <S.Wrapper align={data?.ladoBraco.toUpperCase()} color={colorProg}>
      <S.WrapperGroup align={data?.ladoBraco.toUpperCase()}>
        <S.WrapperHeader
          align={data?.ladoBraco.toUpperCase()}
          ground={ground}
          color={colorProg}
        >
          <IconTruck />
          <span>
            <FilterList />
          </span>
        </S.WrapperHeader>

        <div className="text">
          <Typography>
            <strong>{t('s.cadastro.veiculo.placaveiculo')}:</strong>
            {data?.placa}
          </Typography>
          <Typography>
            <strong>{t('s.menu.operacao.recebimento')}:</strong>
            {data?.programacao}
          </Typography>
          <Typography>
            <strong>{t('s.global.volume')}:</strong>
            {number(data?.volumeProgramado, 0)}
          </Typography>
          <Typography>
            <strong>{t('s.menu.configuracao.produto')}:</strong>
            {data?.produto}
          </Typography>
          {data.volumeAmbienteCarregado >= 0 && (
            <>
              <Typography>
                <strong>
                  {' '}
                  {t('s.relatorio.reltransferencia.volumecarregado')}:
                </strong>
                {number(data?.volumeAmbienteCarregado, 0)}
              </Typography>
              <Typography>
                <strong>{t('s.geral.opcoes.percentual')}:</strong>
                {percentage ? percentage.toFixed(0) : 0}%
              </Typography>
            </>
          )}
          {data.volumeAmbienteDescarregado >= 0 && (
            <>
              <Typography>
                <strong>
                  {' '}
                  {t('s.operacao.recebimentonf.skid.volumerecebido')}:
                </strong>
                {number(data?.volumeAmbienteDescarregado, 0)}
              </Typography>
              <Typography>
                <strong>{t('s.geral.opcoes.percentual')}:</strong>
                {percentageDescarregado ? percentageDescarregado.toFixed(0) : 0}
                %
              </Typography>
            </>
          )}
        </div>
      </S.WrapperGroup>

      {data.volumeAmbienteCarregado >= 0 && (
        <S.ProgressBar
          full={data?.volumeProgramado}
          filled={data?.volumeAmbienteCarregado}
          color={colorProg}
        />
      )}

      {data.volumeAmbienteDescarregado >= 0 && (
        <S.ProgressBar
          full={data?.volumeProgramado}
          filled={data?.volumeAmbienteDescarregado}
          color={colorProg}
        />
      )}
    </S.Wrapper>
  );
}

Truck.propTypes = {
  data: PropTypes.arrayOf(PropTypes.any).isRequired,
  ground: PropTypes.string.isRequired,
};

export default memo(Truck);
